var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStars40InputFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 44,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-public/img/icons/editor/llm/stars_40_input_filled.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-public/img/icons/editor/llm/stars_40_input_filled.svg__b)",
  fillRule: "evenodd",
  d: "M23.219 17.952c-.421 1.317-1.014 2.716-1.783 3.484-.768.769-2.167 1.362-3.484 1.783a20.843 20.843 0 0 1-.908.27l-.254.068c-.38.1-.38.793 0 .894a27.487 27.487 0 0 1 .912.26c.083.025.166.05.25.078 1.317.421 2.716 1.014 3.484 1.782.769.768 1.362 2.168 1.783 3.485a20.843 20.843 0 0 1 .27.907l.068.255c.1.38.793.38.894 0a27.487 27.487 0 0 1 .26-.912c.025-.083.05-.166.078-.25.421-1.317 1.014-2.717 1.782-3.485.768-.768 2.168-1.36 3.485-1.782a20.843 20.843 0 0 1 .907-.27l.255-.068c.38-.1.38-.793 0-.894a27.487 27.487 0 0 1-.912-.26 20.843 20.843 0 0 1-.25-.078c-1.317-.421-2.717-1.014-3.485-1.783-.768-.768-1.36-2.167-1.782-3.484a20.843 20.843 0 0 1-.27-.908 27.487 27.487 0 0 1-.068-.254c-.1-.38-.793-.38-.894 0a27.487 27.487 0 0 1-.26.912l-.078.25Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-public/img/icons/editor/llm/stars_40_input_filled.svg__c)",
  d: "M16.365 12.763a.385.385 0 0 0-.73 0l-.414 1.24a1.926 1.926 0 0 1-1.218 1.218l-1.24.414a.385.385 0 0 0 0 .73l1.24.414a1.926 1.926 0 0 1 1.218 1.218l.414 1.24a.385.385 0 0 0 .73 0l.414-1.24a1.926 1.926 0 0 1 1.218-1.218l1.24-.414a.385.385 0 0 0 0-.73l-1.24-.414a1.926 1.926 0 0 1-1.218-1.218l-.414-1.24Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/icons/editor/llm/stars_40_input_filled.svg__b",
  x1: 31.503,
  x2: 10.179,
  y1: 13.22,
  y2: 15.539,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF55F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA73F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/icons/editor/llm/stars_40_input_filled.svg__c",
  x1: 31.503,
  x2: 10.179,
  y1: 13.22,
  y2: 15.539,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF55F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA73F"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/icons/editor/llm/stars_40_input_filled.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 12h20v20H12z"
})))));
export { SvgStars40InputFilled as ReactComponent };